<template>
  <div>
    <div class="fm-overlay" :class="{ 'fm-overlay--open': open }" @click="$emit('close')"></div>
    <div class="fm-drawer" :class="{ 'fm-drawer--open': open }">
      <div class="fm-drawer-head">
        <div class="fm-drawer-head-row">
          <div style="min-width:0;">
            <div class="fm-drawer-kind">{{ kind }}</div>
            <div class="fm-drawer-title">{{ title }}</div>
          </div>
          <button class="fm-drawer-close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <div v-if="status" class="fm-drawer-status">
          <span class="fm-status-pill" :class="'fm-status-pill--' + tone">
            <span v-if="tone !== 'neu'" class="fm-dot"></span>{{ status }}
          </span>
        </div>
      </div>
      <div class="fm-drawer-body">
        <div v-for="(f, i) in fields" :key="i" class="fm-field">
          <span class="fm-field-label">{{ f.label }}</span>
          <span class="fm-field-value" :class="{ 'fm-mono': f.mono }">{{ f.value }}</span>
        </div>
        <slot name="body"></slot>
      </div>
      <div v-if="$slots.footer" class="fm-drawer-foot">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailDrawer',
  props: {
    open: { type: Boolean, default: false },
    kind: { type: String, default: '' },
    title: { type: String, default: '' },
    status: { type: String, default: '' },
    tone: { type: String, default: 'neu' },
    fields: { type: Array, default: () => [] }
  }
};
</script>
